/**
 * @fileoverview Shared step-flow motion, used by every multi-step arrival flow.
 *
 * Extracted from `OnboardingPage` when founding enrolment became a flow too.
 * It lives here rather than being imported from that page for two reasons: a
 * page importing another page is the wrong dependency direction, and two copies
 * of a transition drift — which would defeat the point, since the whole
 * intention is that enrolment and onboarding feel like one continuous arrival
 * rather than two products bolted together.
 */

/** Horizontal slide keyed to travel direction: +1 forward, -1 back. */
export const slideVariants = {
  enter: (direction) => ({ x: direction > 0 ? 300 : -300, opacity: 0 }),
  center: {
    x: 0,
    opacity: 1,
    transition: { staggerChildren: 0.08, delayChildren: 0.15 },
  },
  exit: (direction) => ({ x: direction > 0 ? -300 : 300, opacity: 0 }),
};

/** Per-element rise, staggered by the parent's `center` transition. */
export const fadeUp = {
  enter: { opacity: 0, y: 16 },
  center: { opacity: 1, y: 0, transition: { duration: 0.35 } },
};

/**
 * How long the founding journey is, counted once so the two pages that render
 * the progress rail cannot disagree about it.
 *
 * A founding teacher walks two enrolment screens and then the one onboarding
 * screen. Those used to be two separate bars — the first finishing at "3 of 3",
 * the second restarting at "1 of 4" — so completing the last step revealed four
 * more. One rail across both is the fix, and it only works if both pages read
 * the same numbers.
 */
export const FOUNDING_STEPS = 2;
// One screen since B3 of the iOS publication review: what you teach, nothing required.
export const ONBOARDING_STEPS = 1;
export const JOURNEY_STEPS = FOUNDING_STEPS + ONBOARDING_STEPS;
